import React, { useEffect } from "react";
import { withNamespaces } from "react-i18next";
import { Card } from "react-bootstrap";
import PersonalAreaRequestTable from "./PersonalAreaRequestTable";
import { closeIframesScreens } from "~/containers/SidebarContainer/util";
import FlowModal from "~/components/FlowModal";

import "~/assets/css/icons.css";

const PersonalAreaRequestPage = ({
  t,
  showFlowModal,
  handleOpenFlowModal,
  handleCloseFlowModal,
  selectedProcess,
  searchFilter,
  sectionName,
}) => {
  useEffect(() => {
    /*close full screen iframes*/
    closeIframesScreens();
  });

  return (
    <>
      <div className="main-card-v2" style={{ width: "100%" }}>
        <Card
          bsPrefix="card-flat"
          style={{ minHeight: "80vh", overflow: "auto" }}
        >
          <Card.Header className="justify-content-between">
            <h6>{t(`${sectionName}`)}</h6>
          </Card.Header>
          <Card.Body>
            <PersonalAreaRequestTable
              handleOpenFlowModal={handleOpenFlowModal}
              searchFilter={searchFilter}
            />
          </Card.Body>
        </Card>
      </div>
      <FlowModal
        showModal={showFlowModal}
        closeModal={handleCloseFlowModal}
        process={selectedProcess}
        isPortal={true}
      />
    </>
  );
};
export default withNamespaces()(PersonalAreaRequestPage);
